if (!window.customElements.get('brands-list')) {
  class BrandsList extends HTMLElement {
    constructor() {
      super();
      this.anchorLinks = this.querySelectorAll('[data-anchor-link]');
      this.timeout = setTimeout(() => this.enableStickyHeader(), 1000);
    }

    connectedCallback() {
      this.anchorLinks.forEach((link) => link.addEventListener('click', () => this.disableStickyHeader()));
    }

    disableStickyHeader() {
      clearTimeout(this.timeout);
      const header = document.querySelector('scroll-header');
      if (!header) return;
      header.setAttribute('data-disable-sticky-header', '');
      this.timeout = setTimeout(() => this.enableStickyHeader(), 1000);
    }

    enableStickyHeader() {
      const header = document.querySelector('scroll-header');
      if (!header) return;
      header.removeAttribute('data-disable-sticky-header');
    }
  }

  window.customElements.define('brands-list', BrandsList);
}